import { all } from 'redux-saga/effects';
import searchFee from './searchFee';

export const searchFeeSaga = function* root() {
  yield all([searchFee()]);
};
